import apiClient from './api';

export const riskAnalysisService = {
  // 회사 위험도 분석
  analyzeCompanyRisk(companyName, file) {
    const formData = new FormData();
    formData.append('company_name', companyName);
    formData.append('file', file);

    return apiClient.post('/risk/analyze-company-risk', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      timeout: 7200000, // 2시간 타임아웃 (7200초)
    });
  },
};
